/**
 * Enforces the card design's 244x370 aspect ratio via JS, ported from
 * blocks/src/shared/card-sizer.js (used by manual-card, category-card,
 * product-card/product-template-card Gutenberg blocks) for reuse across
 * their Elementor widget equivalents.
 *
 * A card's width is fluid (grid/flex child, shrinks on narrow viewports),
 * and CSS `aspect-ratio` on a fluid-width element inside a fluid parent
 * has a real, well-documented circular layout bug (height estimated from
 * a not-yet-resolved width). Measuring the *actual rendered* width after
 * layout and setting an explicit pixel height from it sidesteps that
 * entirely. Exposed as a plain global (no build step for this file) —
 * `window.GWSInitCardSizer( el )`.
 */
( function () {
	'use strict';

	var CARD_WIDTH = 244;
	var CARD_HEIGHT = 370;
	var CARD_RATIO = CARD_HEIGHT / CARD_WIDTH;

	window.GWSInitCardSizer = function ( el ) {
		if ( ! el || typeof ResizeObserver === 'undefined' ) {
			return null;
		}

		var applyHeight = function ( width ) {
			if ( width > 0 ) {
				el.style.height = Math.round( width * CARD_RATIO ) + 'px';
			}
		};

		var observer = new ResizeObserver( function ( entries ) {
			for ( var i = 0; i < entries.length; i++ ) {
				var entry = entries[ i ];
				var inlineSize = entry.contentBoxSize && entry.contentBoxSize[ 0 ] ? entry.contentBoxSize[ 0 ].inlineSize : entry.contentRect.width;
				applyHeight( inlineSize );
			}
		} );

		observer.observe( el );

		return observer;
	};
} )();
